module.exports = __webpack_public_path__ + "static/media/pillar-graphic.f8ed59f6.svg";